const Types = {
    IEnvConfigUtils: Symbol("IEnvConfigUtils"),
    IAreaSelectionUtil: Symbol("IAreaSelectionUtil"),
    IChipUtil: Symbol("IChipUtil"),
    IShiftCalendarUtil: Symbol("IShiftCalendarUtil"),
    ITaskTemplateDetailViewUtil: Symbol("ITaskTemplateDetailViewUtil"),

    ITaskTemplateFilterFactory: Symbol("ITaskTemplateFilterFactory"),
    IChecklistTemplateFilterFactory: Symbol("IChecklistTemplateFilterFactory"),
    IAuditTemplateFilterFactory: Symbol("IAuditTemplateFilterFactory"),

    IUserInfoController: Symbol("IUserInfoController"),
    ITaskController: Symbol("ITaskController"),
    ITaskTemplateController: Symbol("ITaskTemplateController"),
    IAuditTemplateController: Symbol("IAuditTemplateController"),
    IChecklistTemplateController: Symbol("IChecklistTemplateController"),
    IAreaController: Symbol("IAreaController"),
    IShiftController: Symbol("IShiftController"),

    IAuthenticationAction: Symbol("IAuthenticationAction"),
    IErrorHandlingAction: Symbol("IErrorHandlingAction"),
    IMessageToasterAction: Symbol("IMessageToasterAction"),
    ILoadingAction: Symbol("ILoadingAction"),
    ITaskAction: Symbol("ITaskAction"),
    ITaskTemplateAction: Symbol("ITaskTemplateAction"),
    IAuditTemplateAction: Symbol("IAuditTemplateAction"),
    IChecklistTemplateAction: Symbol("IChecklistTemplateAction"),
    IAreaAction: Symbol("IAreaAction"),
    IShiftAction: Symbol("IShiftAction"),

    IAuthenticationService: Symbol("IAuthenticationService")
};

export default Types;


// WEBPACK FOOTER //
// ./src/ServiceProvider/Types.tsx